import { render, staticRenderFns } from "./OrderTypeChart.vue?vue&type=template&id=644d9d8a&scoped=true&"
import script from "./OrderTypeChart.vue?vue&type=script&lang=ts&"
export * from "./OrderTypeChart.vue?vue&type=script&lang=ts&"
import style0 from "./OrderTypeChart.vue?vue&type=style&index=0&id=644d9d8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644d9d8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('644d9d8a')) {
      api.createRecord('644d9d8a', component.options)
    } else {
      api.reload('644d9d8a', component.options)
    }
    module.hot.accept("./OrderTypeChart.vue?vue&type=template&id=644d9d8a&scoped=true&", function () {
      api.rerender('644d9d8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin/components/chart/OrderTypeChart.vue"
export default component.exports